// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1yZgv","ranges":"BmiRanges_ranges__1U-l6"};